import { Gray700 } from '@mehilainen/mds-customer/colors'
import { Button, Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { defaultSelectedTimeRange } from '../../../state/search/atoms'
import { useSearchEvents } from '../../../xstate/events'
import { useSearchFilterOptions } from '../../../xstate/selectors'
import { displayTimerange } from '../DateSelect/TimerangeSelect'
import { Text } from '../Typography/Typography'

const TimerangeTile: React.FC = () => {
  const { t } = useTranslation()
  const filterOptions = useSearchFilterOptions()
  const { setSearchFilters } = useSearchEvents()

  const onRemoveFilter = () => {
    setSearchFilters({
      ...filterOptions,
      timeRange: defaultSelectedTimeRange,
    })
  }

  if (!filterOptions.timeRange) {
    return null
  }

  return (
    <Stack direction="column" spacing={2} alignItems="center" paddingTop="16px">
      <Text $size={200} $weight="Regular" $color={Gray700} $height="Large" $center>
        {t('component.timeRangeTile.label', {
          start: displayTimerange(filterOptions.timeRange.start),
          end: displayTimerange(filterOptions.timeRange.end),
        })}
      </Text>
      <Button onClick={onRemoveFilter} variant="outlined" size="small">
        {t('component.timeRangeTile.removeFilter')}
      </Button>
    </Stack>
  )
}

export default TimerangeTile
